import { Directive } from "@angular/core";

/**
 * Marker directive applied to content projected into the header slot, rendered on the icon's row of
 * `InfoPanelComponent`. Applies the `mgd-info-panel-header` host class and exists so
 * `InfoPanelComponent` can detect via `@ContentChild` whether a consumer projected
 * content into this slot at all. A bare attribute cannot be queried, so the consumer must
 * import this directive wherever the slot is used.
 *
 * @example
 * ```html
 * <mgd-info-panel variant="info">
 *   <span mgdInfoPanelHeader>Language changed</span>
 *   Body content.
 * </mgd-info-panel>
 * ```
 *
 * @selector [mgdInfoPanelHeader]
 */
@Directive({
    selector: "[mgdInfoPanelHeader]",
    host: {
        class: "mgd-info-panel-header"
    }
})
export class InfoPanelHeaderDirective {
}
